<template>
  <v-card class="pa-3 mx-auto media-list-content" min-width="100" :max-width="MAX_CONTENT_WIDTH">
    <h1>{{ title }}</h1>
    <p class="description">{{ description }}</p>
    <div class="info-line">
      <span v-if="owner">by {{ owner.username }} · </span>
      <span v-if="isPrivate"> <v-icon :size="14" color="text lighten-1">mdi-lock</v-icon> private </span>
      <span v-else><v-icon :size="14" color="text lighten-1">mdi-earth</v-icon> public </span>
      <span> · {{ isRanked ? "ranked" : "unranked" }}</span>
    </div>
    <v-divider></v-divider>
    <div class="interactions">
      <v-btn outlined color="text lighten-2" small :to="$route.path + '?edit'">edit</v-btn>
      <v-spacer></v-spacer>
      <select-dense placeholder="sort" :items="['foo', 'bar']"></select-dense>
      <select-dense placeholder="filter" :items="['foo', 'bar']"></select-dense>
    </div>
    <v-divider></v-divider>
    <page-selection
      v-if="totalPages && totalPages > 1"
      :current-page="page"
      :total-pages="totalPages"
      @change="$emit('page-change', $event)"
    ></page-selection>
    <v-divider></v-divider>
    <div v-for="entry in listEntries" :key="entry.position">
      <media-list-entry
        :workId="entry.work.id"
        :medium="entry.work.medium"
        :title="entry.work.title"
        :posterSource="entry.work.posterSource"
        :releaseDate="entry.work.releaseDate"
        :position="isRanked ? entry.position + 1 : undefined"
        display-medium
      ></media-list-entry>
      <v-divider></v-divider>
    </div>
  </v-card>
</template>

<script>
import { MAX_CONTENT_WIDTH } from "../util/constants";
import MediaListEntry from "./media-list-entry.vue";
import SelectDense from "./select-dense.vue";
import PageSelection from "./page-selection.vue";

export default {
  name: "media-list-view-content",

  components: {
    MediaListEntry,
    PageSelection,
    SelectDense,
  },

  props: {
    title: String,
    description: String,
    owner: Object,
    isRanked: Boolean,
    isPrivate: Boolean,
    listEntries: Array,
    totalEntires: Number,
    page: Number,
    totalPages: Number,
  },

  data: function () {
    return {
      MAX_CONTENT_WIDTH,
    };
  },

  methods: {
    enableEdit() {
      this.$router.push(this.$router.currentRoute + "?editMode");
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 24px;
  margin-bottom: 8px;
  line-height: 1;
}

.description {
  color: var(--v-text-lighten1);
  font-size: 14px;
  line-height: 1;
  margin-bottom: 4px;
}

.info-line {
  color: var(--v-text-lighten1);
  font-size: 12px;
  margin-bottom: 8px;
  line-height: 14px;
}
</style>
